module.exports = __webpack_public_path__ + "static/img/KPLFN.915f268.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPLFN.png
// module id = 4Vps
// module chunks = 1